module.exports = __webpack_public_path__ + "img/D7.32726a63.svg";